export const baseURL = process.env.REACT_APP_API_URL;

export const Grades = [{
    name: 'Grade 8 or earlier', value: '1'
}, {
    name: 'Grade 9', value: '2'
}, {
    name: 'Grade 10', value: '3'
}, {
    name: 'Grade 11 or higher', value: '4'
}, {
    name: 'College', value: '5'
}];

export const Subjects = [{
    name: 'DS - Data Science', value: '1'
}, {
    name: 'CS - Computer Science', value: '2'
}, {
    name: 'Both', value: '3'
}];

export const PhysicsCourses = [{
    name: 'AP Physics 1', value: '1'
}, {
    name: 'Ap Physics 2', value: '2'
}, {
    name: 'AP Physics C: Electricity and Magnetism', value: '3',
}, {
     name: 'AP Physics C: Mechanics', value: '4'
}];

export const MathCourses = [{
    name: 'AP PreCalculus', value: '1'
}, {
    name: 'AP Calculus AB', value: '2'
}, {
    name: 'AP Calculus BC', value: '3',
}, {
     name: 'AP Statistics', value: '4'
}];

export const Tests = [{
    name: 'SAT', value: '1'
}, {
    name: 'ACT', value: '2'
}, {
    name: 'Both', value: '3'
}];

export const AreaOfInterest = [{
    name: 'Social', value: '1'
}, {
    name: 'Climate/Environmental', value: '2'
}, {
    name: 'Political/Advocacy', value: '3'
}, {
    name: 'Economic/Finanical', value: '4'
}, {
    name: 'Health & Wellbeing', value: '5'
}, {
    name: 'Technology & Innovation', value: '6'
}, {
    name: 'Education & Literacy', value: '7'
}, {
    name: 'Other:', value: '8'
}];

export const ProjectTypes = [{
    name: 'Build a mobile app', value: '1'
}, {
    name: 'Design a website', value: '2'
}, {
    name: 'Create a nonprofit organization', value: '3'
}, {
    name: 'Raise funding for a social cause', value: '4'
}, {
    name: 'Develop a game (mobile or web)', value: '5'
}, {
    name: 'Start a blog or content platform (for awareness, social causes, etc.)', value: '6'
}, {
    name: 'Launch a podcast or YouTube Channel', value: '7'
}, {
    name: 'Design and prototype a physical product (e.g., gadgets, sustainable products, etc.)', value: '8'
}, {
    name: 'Build a data analysis project (e.g., researching trends, working with big data)', value: '9'
}, {
    name: 'Create a virtual or augmented reality project', value: '10'
}, {
    name: 'Other:', value: '11'
}];

export const SupportTypes = [{
    name: 'Mentorship only (receive guidance and advice)', value: '1'
}, {
    name: 'Training provided (structured courses and modules to learn new skills)', value: '2'
}, {
    name: 'Self-training with resource recommendations (work independently but with curated resources)', value: '3'
}, {
    name: 'Collaborative group work (work with a team of peers on a shared project)', value: '4'
}, {
    name: 'Networking opportunities (connect with experts and like-minded peers)', value: '5'
}, {
    name: 'Hands-on workshops (in-person or virtual sessions)', value: '6'
}, {
    name: 'Other:', value: '7'
}];

export const Skills = [{
    name: 'Beginner', value: '1'
}, {
    name: 'Intermediate', value: '2'
}, {
    name: 'Advanced', value: '3'
}, {
    name: 'Not a familiar', value: '4'
}];

export const WorkingHours = [{
    name: '1-3 hours', value: '1'
}, {
    name: '4-6 hours', value: '2'
}, {
    name: '7-10 hours', value: '3'
}, {
    name: 'More than 10 hours', value: '4'
}];

export const LearningTech = [{
    name: 'Watching tutorials and industrial videos', value: '1'
}, {
    name: 'Reading articals, guides and documentation', value: '2'
}, {
    name: 'Hands-on, trial and error (learning by doing)', value: '3'
}, {
    name: 'Group learning and discussions', value: '4'
}, {
    name: 'Mentorship and direct feedback', value: '5'
}, {
    name: 'Other', value: '6'
}];

export const TeamWork = [{
    name: 'Yes, I have worked on team projects, and I usually take a leadership role.', value: '1'
}, {
    name: 'Yes, I have worked on team projects, and I prefer being an active contributor.', value: '2'
}, {
    name: 'Yes, I have worked on team projects, but I prefer supporting roles (e.g., research, organizing, etc.).', value: '3'
}, {
    name: 'No, I have not worked on team projects, but I am open to learning.', value: '4'
}, {
    name: 'No, I have not worked on team projects, and I prefer individual work.', value: '5'
}];

export const Participations = [{
    name: 'To showcase my technical skills in my college application.', value: '1'
}, {
    name: 'To demonstrate leadership and initiative in my college application.', value: '2'
}, {
    name: 'To explore potential career paths in technology, entrepreneurship, or related fields.', value: '3'
}, {
    name: 'To build a portfolio for college or job applications.', value: '4'
}, {
    name: 'To gain practical skills and experience in a specific area (app development, nonprofit work, etc.).', value: '5'
}, {
    name: 'Other:', value: '6'
}];

export const socialOptions = [{
    name: 'Community service and volunteering', value: '1'
}, {
    name: 'Reducing inequality and discrimination', value: '2'
}, {
    name: 'Youth empowerment', value: '3'
}, {
    name: 'Homelessness reduction', value: '4'
}, {
    name: 'Supporting underprivileged communities', value: '5'
}, {
    name: 'Other:', value: '6'
}];

export const Climates = [{
    name: 'Reducing carbon emissions', value: '1'
}, {
    name: 'Promoting renewable energy', value: '2'
}, {
    name: 'Conservation and biodiversity', value: '3'
}, {
    name: 'Ocean and waterway cleanup', value: '4'
}, {
    name: 'Reducing plastic waste and promoting recycling', value: '5'
}, {
    name: 'Other:', value: '6'
}];

export const Political = [{
    name: 'Promoting democracy and voter participation', value: '1'
}, {
    name: 'Human rights advocacy', value: '2'
}, {
    name: 'Policy change for social good', value: '3'
}, {
    name: 'Political awareness and education', value: '4'
}, {
    name: 'Civic engagement and grassroots organizing', value: '5'
}, {
    name: 'Other:', value: '6'
}];

export const Health = [{
    name: 'Mental health awareness and support', value: '1'
}, {
    name: 'Disease prevention and healthcare access', value: '2'
}, {
    name: 'Fitness and nutrition', value: '3'
}, {
    name: 'Pandemic preparedness and relief efforts', value: '4'
}, {
    name: 'Other:', value: '5'
}];

export const Technology = [{
    name: 'Artificial Intelligence and machine learning', value: '1'
}, {
    name: 'Robotics and automation', value: '2'
}, {
    name: 'Blockchain and cryptocurrency', value: '3'
}, {
    name: 'Virtual and augmented reality', value: '4'
}, {
    name: 'Space exploration and astrophysics', value: '5'
}, {
    name: 'Other:', value: '6'
}];

export const Education = [{
    name: 'Increasing access to education in underprivileged areas', value: '1'
}, {
    name: 'Promoting STEM education', value: '2'
}, {
    name: 'Digital literacy and access to technology', value: '3'
}, {
    name: 'Creating educational resources or platforms', value: '4'
}, {
    name: 'Other:', value: '5'
}];